import restaurantReportsActions from '../actionTypes/restaurantReportsActions';
import dateTimeHelpers from '../utils/dateTimeHelpers';

const initialState = {
  isLoading: true,
  data: {
  },
  success: true,
  message: '',
  from: dateTimeHelpers.dateBeforeMonths(1),
  to: dateTimeHelpers.today().dateTime,
};

const restaurantReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case restaurantReportsActions.getRestaurantReports:
      return { ...state, ...action.payload, isLoading: true };
    case restaurantReportsActions.getRestaurantReportsSuccess:
      return { ...state, ...action.payload, isLoading: false };
    case restaurantReportsActions.getRestaurantReportsFailed:
      return { ...state, ...action.payload, isLoading: false };
    default:
      return state;
  }
};

export default restaurantReportsReducer;
